module.exports = __webpack_public_path__ + "location_70x70.1a358e62f141ef5d173961506782faf1.png";